import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row} from "react-bootstrap";
import {connect} from "react-redux";
import {REQUEST} from "../../../config/ajax-wrapper";
import {DotLoader} from "react-spinners";
import {Mensaje} from "../../general/componentes/Mensaje";
import {actualizarTipoDocumental, consultarDocumentoP8} from "../modulos/documentosActions";
import {DocumentoP8} from "../modelo/DocumentoP8";
import TipoDocumental from "../../general/componentes/TipoDocumental";
import {obtenerTipoDocumental, obtenerMimePdf} from "../modelo/TiposDocumental";
import VisualizadorPDF from './VisualizadorPDF';
import NavegadorImagen from "./NavegadorImagen";
import "./Documentos.css";

class VisorDocumento extends React.Component<any, any> {

    IMAGE_MIME_TYPE = "image/";
    PDF_MIME_TYPE = "application/pdf";

    constructor(props: any) {
        super(props);

        this.state = {
            idDocumento: this.props.match.params.idDocumento,
            tipoDocumental: this.props.match.params.tipoDocumental,
            dni: this.props.match.params.dni,
            tipoCliente: this.props.match.params.tipoCliente,
            titulo:this.props.match.params.titulo,
            angulo: 0,
            zoom: false,
            zoomImage: 'auto',
            openDocument: false,
            clase: 'imagen-arriba'
        };
    }

    componentDidMount() {
        this.props.dispatch(consultarDocumentoP8(this.state.idDocumento));
    }

    render() {
        const {estadoConsulta} = this.props;

        switch (estadoConsulta) {
            case REQUEST.SUCCESS:
                return this.renderDocumento();
            case REQUEST.ERROR:
                return (
                    <Mensaje type={"danger"}
                             mensaje={"Se ha presentado un error obteniendo el documento de P8"}/>
                );
            case REQUEST.PENDING:
                return (
                    <label>Obteniendo Documento...<DotLoader size={25}/></label>
                );
            default:
                return (
                    <label>Cargando...<DotLoader size={25}/></label>
                );
        }
    }

    renderDocumento() {
        const {documentosP8} = this.props;
        const documentoP8: DocumentoP8 = documentosP8.find(d =>
            d.idDocument.includes(this.state.idDocumento));

        if (obtenerMimePdf(documentoP8.mimeType)) {
            return this.renderPDF(documentoP8);
        } else if (documentoP8.mimeType.includes(this.IMAGE_MIME_TYPE)) {
            return this.renderImage(documentoP8);
        } else {
            return (
                <Mensaje type={"danger"}
                         mensaje={"El documento ha sido cargado en un formato no reconocido"}/>
            );
        }
    }

    renderPDF(documentoP8: DocumentoP8) {
        const documento = documentoP8.content;
        return (
            <div className={"cardPDF"}>
                <div className={"card-header"}>
                    {this.renderTipoDocumental()}
                    {this.renderBtnGirar()}
                </div>
                <div className={`card-body ${this.state.clase}`}>
                    <Col>
                        <VisualizadorPDF 
                            documentoBase64={documento}
                            showBtnRotate={this.showBtnRotate}
                        />
                    </Col>
                </div>
            </div>
        );
    }

    renderImage(documentoP8: DocumentoP8) {
        return (
            <div className={"cardImage"}>
                <div className={"card-header"}>
                    {this.renderTipoDocumental()}
                    <Row>
                        <Col sm={1}>
                            <button type="button" className="btns btns-primary" onClick={() => this.girar()}>Girar</button>
                        </Col> 
                        <Col sm={4}> 
                            <NavegadorImagen 
                                zoomImage={this.state.zoomImage}
                                eventZoomInImage={this.eventZoomInImage}
                                eventZoomOutImage={this.eventZoomOutImage}
                            />
                        </Col>
                    </Row>
                </div>
                <div className={"card-body visor-documentos"} >
                    <Col>
                        <img className={(this.state.zoom) ? "imagen-zoom-in": "imagen-zoom-out"} 
                            id="imagen"
                            style={{transform: `translateY(10%) rotate(${this.state.angulo}deg)`,  width: `${this.state.zoomImage}`,  height: `${this.state.zoomImage}`}} 
                            src={`data:${documentoP8.mimeType};base64,${documentoP8.content}`}
                            onClick={() => this.zoom()}
                        />
                    </Col>
                </div>
            </div>
        );
    }

    zoom() {
        this.setState((prevState) => ({zoom: !prevState.zoom, zoomImage: (prevState.zoomImage !== '100%') ? '100%':'auto'})); 
    }

    girar() {
        this.definirRotacionPdf();
        this.setState((prevState) => ({angulo: prevState.angulo  + 90}));
    }

    definirRotacionPdf() {
        if(this.state.clase === 'imagen-arriba') {
            this.setState(() => ({clase: 'imagen-derecha' }));
        } else if(this.state.clase === 'imagen-derecha') {
            this.setState(() => ({clase: 'imagen-abajo' }));
        } else if(this.state.clase === 'imagen-abajo') {
            this.setState(() => ({clase: 'imagen-izquierda' }));
        } else if(this.state.clase === 'imagen-izquierda') {
            this.setState(() => ({clase: 'imagen-arriba' }));
        }
    }
    
    renderTipoDocumental() {
        const {estadoTipoDocumental} = this.props;

        switch (estadoTipoDocumental) {
            case REQUEST.SUCCESS:
                return (
                    <span>
                        <Mensaje type={"success"}
                                 mensaje={"El tipo documental se ha actualizado correctamente"}/>
                        {this.tipoDocumentalBody()}
                    </span>
                );
            case REQUEST.ERROR:
                return (
                    <span>
                        <Mensaje type={"danger"}
                                 mensaje={"Se ha presentado un error actualizando el tipo documental"}/>
                        {this.tipoDocumentalBody()}
                    </span>
                );
            case REQUEST.PENDING:
                return (
                    <label>Actualizando Tipo Documental...<DotLoader size={25}/></label>
                );
            default:
                return this.tipoDocumentalBody();
        }
    }

    tipoDocumentalBody = () => {
        return (
            <div>
                <Row>
                    <Col sm={4}>
                        <h3 className={"panel-title"}>{this.state.titulo}</h3>
                    </Col>
                    <Col sm={8}>
                        <Form
                            onSubmit={this.actualizarTipoDocumental}
                            initialValues={{titulosDocumentales: this.state.titulo}}
                            render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                                <form onSubmit={handleSubmit}>
                                    <Row className="form-group">
                                        <Col smOffset={4} sm={5}>
                                            <label htmlFor="tipoDocumental">Tipo Documental</label>
                                            <TipoDocumental name="titulosDocumentales" tipoCliente={this.state.tipoCliente}/>
                                        </Col>
                                        <Col sm={3}>
                                            <button type="submit" className="btns btns-primary"
                                                    disabled={submitting || invalid} style={{margin: 18}}>
                                                Actualizar
                                            </button>
                                        </Col>
                                    </Row>
                                </form>
                            )}
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    actualizarTipoDocumental = values => {
        this.setState({tipoDocumental: values.tipoDocumental});
        let tipoDocP8 = obtenerTipoDocumental(values.titulosDocumentales);
        this.props.dispatch(actualizarTipoDocumental(tipoDocP8.tipoDocumental,
            this.state.dni, this.state.idDocumento, tipoDocP8.titulo));
    };

    eventZoomInImage = () => {
        if(this.state.zoomImage === '130%') return;
        this.setState((prevState: any) => (
            { zoomImage: (prevState.zoomImage === 'auto') ? '110%':(parseFloat(prevState.zoomImage) + parseFloat('10%'))+'%' }
        ));
    }

    eventZoomOutImage = () => {
        if(this.state.zoomImage === '70%') return;
        this.setState((prevState: any) => (
            { zoomImage: (prevState.zoomImage === 'auto') ? '90%':(parseFloat(prevState.zoomImage) - parseFloat('10%'))+'%' }
        ));
    }

    showBtnRotate = () => {
        this.setState((prevState: any) => ({openDocument: !prevState.openDocument}));
    }

    renderBtnGirar() {
        if(this.state.openDocument) {
            return(
                <button type="button" className="btns btns-primary" onClick={() => this.girar()}>Girar</button>
            );
        }
        return;
    }
}

export default connect((store: any, props: any) => {
    return {
        ...props,
        estadoConsulta: R.pathOr(REQUEST.NONE, ["documentos", "estadoP8"])(store),
        estadoTipoDocumental: R.pathOr(REQUEST.NONE, ["documentos", "estadoTipoDocumental"])(store),
        documentosP8: R.pathOr([], ["documentos", "documentosP8"])(store),
        tipoCliente: R.pathOr("", ["documentos", "tipoCliente"])(store)
    };
})(VisorDocumento);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/VisorDocumento.tsx